import PropTypes from 'prop-types';
import {renderMarkdown} from 'helpers/text-helper';
import {getText} from 'helpers/language-helper';
import Audio from 'components/ui/audio/audio';
import './branching-story-info.scss';

const BranchingStoryInfo = ({languageId, taskId, moduleId, deviceInfo, storyStepData}) => {
	if (!storyStepData) return null;
	
	return (
		<div className={'BranchingStoryInfo ' + deviceInfo.orientation}>
			{/* Title and text */}
			{(storyStepData.title || storyStepData.text) && 
				<div className="BranchingStoryInfo-textBox">
					{storyStepData.title && 
						<div className="BranchingStoryInfo-title">
							<span>{getText(storyStepData.title, languageId)}</span>
						</div>}
					{storyStepData.text && 
						<div className="BranchingStoryInfo-text">
							{renderMarkdown(getText(storyStepData.text, languageId))}
							<div className="BranchingStoryInfo-audio">
								<Audio 
									type='task-option'
									languageId={languageId}
									moduleId={moduleId}
									fileName={languageId + '-' + taskId + '-' + storyStepData.id}
								/>
							</div>
						</div>}
				</div>
			}
		</div>
	);
};

BranchingStoryInfo.propTypes = {
	languageId: PropTypes.string.isRequired,
	taskId: PropTypes.string.isRequired,
	moduleId: PropTypes.string.isRequired,
	deviceInfo: PropTypes.object.isRequired,
	storyStepData: PropTypes.object.isRequired
};

export default BranchingStoryInfo;
